<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

const props = defineProps<{
  class?: HTMLAttributes['class']
  classContentWrapper?: HTMLAttributes['class']
  perPage?: 4 | 3
  items: {
    title?: string
    description?: string
  }[]
  hideNavButton?: boolean
}>()
</script>

<template>
  <UiCarouselBase
    :class="cn('relative', props.class)"
    class-content-container="gap-2 lg:gap-5 flex-col lg:flex-row"
    :class-content="[
      'basis-full md:basis-[calc(51%-29px) relative lg:basis-[calc(33.33%-16px)]',
      {
        ' lg:basis-[calc(25%-16px)]': props.perPage === 4
      }
    ]"
    :class-content-wrapper="props.classContentWrapper"
    :items="props.items"
    :plugins="[WheelGesturesPlugin()]"
    :options="{
      active: false,
      breakpoints: {
        '(min-width: 1024px)': { active: true }
      }
    }"
  >
    <template #content="{ item, index }">
      <div
        v-if="index !== 0"
        class="hidden lg:block absolute z-0 -left-14 top-1/2 -translate-y-1/2 w-14 h-3 carousel-gap-linier-repeat"
      ></div>
      <div class="py-2 h-full">
        <UiCardFeature
          class="h-full z-10 dark:bg-surface-container-highest"
          wrapper-class="dark:bg-surface-container-highest"
          :icon="`material-symbols:counter-${index + 1}-outline`"
          :title="item.title"
          :description="item.description"
        />
      </div>
    </template>

    <template
      v-if="!props.hideNavButton"
      #default="{
        isDisabledPrevButton,
        isDisabledNextButton,
        onNextButtonClick,
        onPrevButtonClick
      }"
    >
      <div
        class="absolute top-1/2 -translate-y-1/2 -right-11 z-10 gap-2 items-center hidden lg:flex"
      >
        <UiButton
          v-if="!isDisabledNextButton"
          class="px-2 rounded-full flex-none cursor-pointer bg-background border border-outline-variant"
          icon="material-symbols:chevron-right"
          aria-label="Nav next"
          variant="container"
          icon-size="lg"
          size="sm"
          @click="onNextButtonClick"
        />
      </div>
      <div
        class="absolute top-1/2 -translate-y-1/2 -left-11 z-10 gap-2 items-center hidden lg:flex"
      >
        <UiButton
          v-if="!isDisabledPrevButton"
          class="px-2 rounded-full flex-none cursor-pointer bg-background border border-outline-variant"
          icon="material-symbols:chevron-left"
          aria-label="Nav prev"
          variant="container"
          icon-size="lg"
          size="sm"
          @click="onPrevButtonClick"
        />
      </div>
    </template>
  </UiCarouselBase>
</template>
